var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _vm.currentJob.apiJob.errors[0].code === 6020
      ? _c(
          "div",
          {
            staticClass: "card premium-bg mb-3 hidden",
            attrs: { id: "max-execution-time-alert" },
          },
          [
            _c("div", { staticClass: "card-header no-border text-white" }, [
              _c(
                "span",
                {
                  staticClass:
                    "font-weight-bold font-size-150 gap-15 d-flex align-items-center",
                },
                [
                  _c("i", { staticClass: "far fa-clock" }),
                  _vm._v(" " + _vm._s(_vm.getMaxExecutionTitle())),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body text-white" }, [
              _vm.isFreeUser
                ? _c("p", { staticClass: "font-size-125" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("trans")(
                            "Get %project% Premium to increase your processing time per task.",
                            { "%project%": this.projectName }
                          )
                        ) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isFreeUser
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-warning font-weight-bold payment-btn",
                      on: { click: _vm.openPremium },
                    },
                    [
                      _vm._v(_vm._s(_vm._f("trans")("Go Premium")) + " "),
                      _c("i", { staticClass: "fa fa-arrow-right" }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-default font-weight-bold",
                  attrs: { id: "payment-redo-btn", href: "#" },
                  on: { click: _vm.openGoBack },
                },
                [
                  _c("i", { staticClass: "fa fa-redo" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("trans")("Go back and try another file"))
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.isFreeUser
              ? _c("div", { staticClass: "card-footer no-border text-white" }, [
                  _c("i", { staticClass: "far fa-info-circle pr-1" }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("trans")(
                          "Processing tasks for a long time costs a lot of server resources and is only possible for paying users."
                        )
                      ) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "p-2 bg-white border rounded" }, [
      _c("div", { staticClass: "alert alert-danger pt-4 mb-0" }, [
        _c("p", [
          _c("strong", [
            _c("i", { staticClass: "lh-inherit far fa-info-circle" }),
            _vm._v(" " + _vm._s(_vm._f("trans")("Something went wrong"))),
          ]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(
              this.getTranslatedError(_vm.currentJob.apiJob.errors[0].code)
            )
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }